module.exports = __webpack_public_path__ + "img/service-03-pic-1.3a590d3a.gif";